export default __webpack_public_path__ + "static/media/altelios.c944595b.webp";